import {
  Component,
  OnInit,
  Input,
  Injectable,
  ViewEncapsulation,
} from "@angular/core";
import { Router, ActivatedRoute } from "@angular/router";
import { LoginService } from "../../services/login.service";
import {
  FormControl,
  Validators,
  FormGroup,
  FormBuilder,
  NgForm,
  ValidatorFn,
  AbstractControl,
} from "@angular/forms";
import { first } from "rxjs/operators";
import { environment } from "../../../environments/environment";
import { HttpClient, HttpHeaders, HttpResponse } from "@angular/common/http";
import { NotifierService } from "angular-notifier";
import { TokenStorageService } from "../../services/token-storage.service";
import { UserService } from "../../services/user.service";
import { ErrorService } from "../../services/error.service";
import { MatDialog } from "@angular/material/dialog";
import { EulaDialogComponent } from "../eula-dialog/eula-dialog.component";
import { UtilService } from "../../services/util.service";
import { OrganisationService } from "../../services/settings/organisation.service";

@Component({
  selector: "app-login",
  templateUrl: "./login.component.html",
  styleUrls: ["./login.component.scss"],
  encapsulation: ViewEncapsulation.None,
})
export class LoginComponent implements OnInit {
  private asgAdminUrl = environment.asgAdminUrl;
  private asgSecurityUrl = environment.asgSecurityUrl;
  private readonly notifier: NotifierService;
  loginForm: FormGroup;
  Email: string = "";
  Password: string = "";
  errorMessage: string;
  hide: boolean = true;
  public updateInfo = false;
  public showHelpIcon: boolean = false;

  constructor(
    private login: LoginService,
    private userService: UserService,
    private router: Router,
    private fb: FormBuilder,
    private notifierService: NotifierService,
    private http: HttpClient,
    private token: TokenStorageService,
    public dialog: MatDialog,
    private errSer: ErrorService,
    private utilService: UtilService,
    private orgService: OrganisationService
  ) {
    this.notifier = notifierService;
    this.loginForm = fb.group({
      email: [
        null,
        Validators.compose([Validators.required, Validators.email]),
      ],
      password: [null, Validators.required],
    });
    this.dialog.closeAll();
    //console.log("Closed all dialogs");
  }

  ngOnInit() {
    this.dialog.closeAll();
    //console.log("Closed all dialogs");
  }

  openInfo() {
    if (this.updateInfo) {
      this.updateInfo = false;
    } else {
      this.updateInfo = true;
    }
  }
  ShowHelpIcon() {
    if (!this.showHelpIcon) {
      this.showHelpIcon = true;
    }
  }
  ShowHelp() {
    if (!this.showHelpIcon) {
      this.showHelpIcon = true;
      this.login.setZendeskView(false);
    }
  }

  public onFormSubmit(credentials) {
    this.notifier.notify("info", "Processing...", "0");
    let data;
    this.login.doLogin(credentials).subscribe((myRes: HttpResponse<any>) => {
      data = myRes.body;
      this.notifier.hide("0");
      window.sessionStorage.setItem('loginUserName', credentials.email);
      let mfaAlgorithm = myRes.headers.get("x-asg-security-mfa-enabled");
      if (mfaAlgorithm && mfaAlgorithm.toLowerCase() == "totp" && data == null) {
        this.router.navigate(['/mfa']);
        return;
      } else {
        if(data && data.systemAccount) {
          this.notifier.notify("error","Login Unsuccessful. Invalid account type","0");
          this.token.signOut();
          return;
        }else{
          this.loginSuccess(data);
        }
      }
      
    });
  }
  loginSuccess(data) {
    if (data.eulaEnabled === 'y' &&
    (data.eulaAccepted === 'n' || !data.eulaAccepted)) {
      const dialogRef = this.dialog.open(EulaDialogComponent, {
        autoFocus: false,
        disableClose: true,
        data: { userRsp : data}
      });
    }  else {
      window.sessionStorage.setItem("loggedInUser", JSON.stringify(data));
      window.sessionStorage.setItem("setPassword", data.changePassword);
      localStorage.setItem("loggedInUser", JSON.stringify(data));
      localStorage.setItem("setPassword", data.changePassword);

      let orgId = JSON.parse(localStorage.getItem("loggedInUser")).orgId;
      this.orgService.getOrgBasicConfigData(orgId).then((response) => {
        localStorage.setItem("orgConfig", JSON.stringify(response[0]));
      });
      this.login.navigateToHomePage();
    }
  }

  public getEmailErrorMsg() {
    return this.loginForm.get("email").hasError("required")
      ? "You must enter username"
      : this.loginForm.get("email").hasError("email")
      ? "Not a valid username"
      : "";
  }

  public getPasswordErrorMsg() {
    return this.loginForm.get("password").hasError("required")
      ? "You must enter password"
      : this.loginForm.get("Password").hasError("invalid")
      ? "Password is incorrect, try again"
      : null;
  }

  loginInputChange() {
    if (
      this.loginForm.controls.email.value == "" &&
      this.loginForm.controls.password.value == "" &&
      document.getElementsByClassName("login-btn")
    ) {
      Array.from(
        document.getElementsByClassName(
          "login-btn"
        ) as HTMLCollectionOf<HTMLElement>
      )[0].classList.add("no-data-login-btn");
      Array.from(
        document.getElementsByClassName(
          "login-btn"
        ) as HTMLCollectionOf<HTMLElement>
      )[0].classList.remove("login-btn");
    } else {
      if (document.getElementsByClassName("no-data-login-btn")[0]) {
        Array.from(
          document.getElementsByClassName(
            "no-data-login-btn"
          ) as HTMLCollectionOf<HTMLElement>
        )[0].classList.add("login-btn");
        Array.from(
          document.getElementsByClassName(
            "no-data-login-btn"
          ) as HTMLCollectionOf<HTMLElement>
        )[0].classList.remove("no-data-login-btn");
      }
    }
  }

  hasClass() {
    if (
      document.getElementById("myLauncher") &&
      document.getElementById("myLauncher").classList.contains("help-icon")
    ) {
      this.showHelpIcon = false;
    } else if (
      document.getElementById("myLauncher") &&
      document
        .getElementById("myLauncher")
        .classList.contains("help-icon-click")
    ) {
      this.showHelpIcon = true;
    }
    return this.showHelpIcon;
  }
}
